"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M29.585 29.5c.249.25.417.583 0 .917l-5.168 3.333c-.417.25-.583.083-.75-.334l-6.416-11.168L8.833 31.5c-.083.167-.334.333-.583 0l-4-4.167c-.417-.25-.334-.5 0-.75l9.5-7.917L2.917 14.58c-.168 0-.417-.333-.251-.75L5.5 8.164A.439.439 0 0 1 6.25 8l9.5 6.167L16.335 2a.438.438 0 0 1 .5-.5l6.917.916c.417 0 .5.167.417.583l-3.25 11.917 11-3.333c.249-.167.5-.167.666.333l1.084 6.167c.083.417 0 .583-.334.583l-11.5.917z" })
);

